import { render, staticRenderFns } from "./TeamOrganogram.vue?vue&type=template&id=391a327a&"
import script from "./TeamOrganogram.vue?vue&type=script&lang=js&"
export * from "./TeamOrganogram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports